import { render, staticRenderFns } from "./module-list.vue?vue&type=template&id=c8fb8f6a&scoped=true"
import script from "./module-list.vue?vue&type=script&lang=js"
export * from "./module-list.vue?vue&type=script&lang=js"
import style0 from "./module-list.vue?vue&type=style&index=0&id=c8fb8f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fb8f6a",
  null
  
)

export default component.exports